<script>
import NotificationBubble from '@components/notifications/notification-bubble.vue';
import { authComputed } from '@state/helpers';

import { reInitGlobalUnreadCount } from '@state/chatService';

export default {
  components: {
    NotificationBubble,
  },
  props: {},
  data() {
    return {
      placeholder: require('@assets/images/placeholder-avatar.png'),
      showDropdownMenu: false,
    };
  },
  computed: {
    ...authComputed,
    isAdmin() {
      return (
        this.currentUser &&
        this.currentUser.roles &&
        this.currentUser.roles.isAdmin
      );
    },
    role() {
      return this.roles && this.roles.length > 0 && this.roles[0];
    },
    userAvatar() {
      return this.role && this.role === 'isAdmin'
        ? this.placeholder
        : this.currentUser &&
          this.currentUser.trainer &&
          this.currentUser.trainer.mediaAssets &&
          this.currentUser.trainer.mediaAssets.avatarImage &&
          this.currentUser.trainer.mediaAssets.avatarImage.url
        ? this.currentUser.trainer.mediaAssets.avatarImage.url
        : this.placeholder;
    },
    userName() {
      return this.role && this.role === 'isAdmin'
        ? 'Admin'
        : this.role === 'isTrainer' &&
            this.currentUser &&
            this.currentUser.trainer &&
            this.currentUser.trainer.firstName;
    },
    appVersion() {
      return process.env.VUE_APP_VERSION;
    },
  },
  mounted() {
    if (this.currentUser) {
      reInitGlobalUnreadCount();
    }
  },
  methods: {
    toMessages() {
      this.$router.push({ name: 'messages' }).catch(() => {});
    },
    imageUrlAlt(event) {
      event.target.src = this.placeholder;
    },
    toggleDropdownMenu() {
      this.showDropdownMenu = !this.showDropdownMenu;
    },
  },
};
</script>

<template>
  <div class="username-block">
    <div
      class="messages"
      @click="toMessages"
      v-if="currentUser && currentUser.roles && currentUser.roles.isTrainer"
    >
      <NotificationBubble
        v-if="totalUnread && totalUnread > 0"
        type="count"
        :content="totalUnread"
      />
      <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon-chat new'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.75.85V8.5c0 .467-.383.85-.85.85H3.4L0 12.75V.85C0 .383.383 0 .85 0H11.9c.467 0 .85.383.85.85zm1.7 2.55h1.7c.468 0 .85.383.85.85V17l-3.4-3.4H4.25a.852.852 0 01-.85-.85v-1.7h11.05V3.4z" fill="#000"/></svg>
    </div>
    <div class="user-details" @click="toggleDropdownMenu">
      <div class="avatar">
        <img :src="userAvatar" @error="imageUrlAlt" />
      </div>
      <div class="user-info">
        <h6 class="user-full-name">{{ userName }}</h6>
      </div>
    </div>

    <div class="profile-links">
      <div
        :class="[
          'profile-dropdown-menu',
          { 'dropdown-visible': showDropdownMenu },
        ]"
      >
        <ul>
          <router-link to="/logout" tag="li">Logout</router-link>
        </ul>
        <div class="version"
          ><strong>App Version: {{ appVersion }}</strong></div
        >
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.username-block {
  display: flex;
  position: relative;
  width: 17rem;

  .profile-links .profile-dropdown-menu {
    background-color: $color-off-white;
    border: 0;
    border-radius: 0;
    box-shadow: 0 0.2rem 0.4rem rgba($color-black-wo-rgb, 0.08);
    display: none;
    float: left;
    font-size: 1rem;
    left: 0;
    min-height: 1rem;
    min-width: 19rem;
    position: absolute;
    text-align: left;
    top: 2.8rem;
    z-index: 1000;

    &.dropdown-visible {
      display: block;
      left: 0;
      position: absolute;
      transform: translate3d(0, 2.5rem, 0);
      will-change: transform;
    }

    li {
      padding: 0.5rem 1rem;

      &:hover {
        background-color: white;
        cursor: pointer;
      }
    }
    .version {
      font-size: 130%;
      margin-bottom: 1rem;
      margin-left: 1rem;
      margin-top: 2rem;
    }
  }

  .messages {
    align-items: center;
    display: flex;
    position: relative;
    transition: transform 200ms;
    transition-timing-function: ease-out;
    &:hover {
      box-shadow: 0 0.4rem 0.8rem rgba($color-black-wo-rgb, 0.1);
      cursor: pointer;
      transform: scale(1.2);
    }

    .icon-chat {
      margin-right: 2.5rem;
      outline: none;
      @include media('xxxl', null) {
        margin-right: 3rem;
      }
      path {
        fill: white;
      }

      &.new {
        path {
          fill: $color-action;
        }
      }
    }

    .notification-bubble {
      height: 1.8rem;
      left: -0.7rem;
      top: 0;
      width: 1.8rem;
    }
  }

  .user-details {
    display: flex;

    &:hover {
      cursor: pointer;
    }

    .avatar {
      height: auto;
      margin-right: 1.5rem;
      width: 25%;

      img {
        border-radius: 50%;
        height: 3rem;
        object-fit: cover;
        width: 3rem;
      }
    }

    .user-info {
      align-items: center;
      display: flex;
      flex-wrap: wrap;
      text-align: left;
    }

    .user-full-name {
      color: white;
      font-size: 1.4rem;
      font-weight: bold;
      letter-spacing: 0.35px;
      line-height: 1.7rem;
      margin-bottom: 0;
    }

    .user-email {
      color: white;
      font-size: 1.2rem;
      font-weight: 600;
      letter-spacing: 0.275px;
      line-height: 0.9rem;
      margin-bottom: 0;
      mix-blend-mode: normal;
      opacity: 0.4;
    }
  }
}
</style>
